<script setup lang="ts">
import { computed, ref } from "vue";
import { __color, getCSSVar } from "@zyzgroup/core-web";
import SVGDelete from "../svg/SVGDelete.vue";
import Box from "../base/Box.vue";
import Pan from "../base/Pan.vue";
import Tap from "../base/Tap.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { SVGDelete },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    deleteColor?: string;
    borderRadius?: string;
    deleteWidth?: string;
    transtionDuration?: string;
  }>(),
  {
    deleteColor: getCSSVar("--yz-xg-red", "#fa503c"),
    borderRadius: "4px",
    deleteWidth: "44px",
    transtionDuration: "150ms"
  }
);

const emits = defineEmits<{
  (event: "delete"): void;
}>();

const isShowDelete = ref(false);

const oppositeDeleteColor = computed(() =>
  __color.set(props.deleteColor).opposite(true).toString()
);

const click = () => {
  isShowDelete.value = false;
  emits("delete");
};

function open() {
  isShowDelete.value = true;
}
function close() {
  isShowDelete.value = false;
}

defineExpose({ open, close });
</script>

<template>
  <Box
    class="slide-left-item"
    :style="{
      overflow: 'hidden',
      borderRadius: props.borderRadius
    }"
  >
    <Tap @out-side="close">
      <Pan
        @left="open"
        @right="close"
      >
        <div
          class="content"
          :style="{
            transition: 'all ease-in ' + props.transtionDuration,
            transform: isShowDelete
              ? 'translate(-' + props.deleteWidth + ', 0)'
              : 'translate(0, 0)'
          }"
        >
          <slot></slot>
        </div>
        <div
          class="delete"
          @click="click"
          :style="{
            backgroundColor: props.deleteColor,
            width: props.deleteWidth,
            transition: 'all ease-in ' + props.transtionDuration,
            transform: isShowDelete
              ? 'translate(0, 0)'
              : 'translate(' + props.deleteWidth + ', 0)'
          }"
        >
          <div style="width: 38%">
            <SVGDelete :color="oppositeDeleteColor"></SVGDelete>
          </div>
        </div>
      </Pan>
    </Tap>
  </Box>
</template>

<style scoped>
.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.delete {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
